import * as selectors from './selectors'
import * as actions from './actions'
import { default as AdvancedAlertModal, EventProps, ValueProps } from './AdvancedAlertModal'
import { AppState, Dispatch } from '../../../../types'
import { connect } from 'react-redux'

const mapProps = (state: AppState): ValueProps => ({
  isAdvancedAlertModalOpened: selectors.isAdvancedAlertModalOpened(state)
})

const mapDispatch = (dispatch: Dispatch): EventProps => ({
  handleClose: () => dispatch(actions.handleClose())
})

export default connect(mapProps, mapDispatch)(AdvancedAlertModal)
